import { useTranslate } from '@repo/shared/hooks'
import { Input } from '@repo/ui/components'
import type { OrderBoxPriceInputProps } from './order-box.types'

export const OrderBoxPriceInput = ({
  value,
  onChange,
}: OrderBoxPriceInputProps) => {
  const { t } = useTranslate()
  return (
    <Input
      type='number'
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      min={0}
      inputSize='md'
      endLabel={t('currency_toman')}
      className='mb-xs'
    />
  )
}
